export default __webpack_public_path__ + "dee9b2f.png";